export default __webpack_public_path__ + "static/media/android.9e98e7af.png";